/**
 * URL Parameters Utility
 *
 * The PARK app opens the portal with a short-lived `?token=` that MIRA issued.
 * The portal exchanges it for a session token at start-up and then
 * removes it from the address bar, so it does not linger in history or links.
 */

/** The portal token in a query string, or null when it is missing or empty. */
export function readPortalToken(search: string): string | null {
  return new URLSearchParams(search).get('token') || null;
}

/** Removes `token` from the address bar and keeps the path, the other parameters and the hash. */
export function stripPortalTokenFromUrl(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('token')) return;
  url.searchParams.delete('token');
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
}
